/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragAndDropComponent} from './drag-and-drop.component';
import {DragAndDropDirective} from './directive/drag-and-drop.directive';
import {ReactiveFormsModule} from '@angular/forms';
import {WarningsModule} from '../warnings/warnings.module';

@NgModule({
    declarations: [DragAndDropComponent, DragAndDropDirective],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        WarningsModule
    ],
    exports: [DragAndDropComponent]
})
export class DragAndDropModule {
}
